



import { useNavigate } from 'react-router-dom';
import HomeLf from './HomeLf';
import sobreimg from '../assets/version2/framesobre.png';
import group1 from '../assets/version2/group1.png';
import group2 from '../assets/version2/group2.png';
import group3 from '../assets/version2/group3.png';
import group4 from '../assets/version2/group4.png';
import './sobre.css'
import sobreimg2 from '../assets/version2/sobreimg2.png';
import Rodape from './Rodape';
import { useEffect, useState } from 'react';
import HomeOff from './HomeOff';
import { onAuthStateChanged } from 'firebase/auth';
import { firebaseAuth } from '../utils/firebase-config';
var runtime = 0;
function Sobre() {


const navigate = useNavigate();
const [current, setCurrent] = useState('');
const [logado, setLogado] = useState(false);

if(window.location.href.slice(window.location.href.length - 1, window.location.href.length) != '/') {
  document.querySelector('.oisumida').style.display = 'none';
} else {

  document.querySelector('.oisumida').style.display = 'block';
  
}


async function master(params) {
  


    onAuthStateChanged(firebaseAuth, async (currentUser) => {
            if (currentUser) {setLogado(true);
             setCurrent(currentUser.email);
         







        } else {
            
        }
          });





}


useEffect(()=> {

  master();

},[])

  return (
    <>
    {logado == true ? <><HomeLf/></> : <> <HomeOff/></>}


<div className="fixmargin"></div>


<container>
<div className='col-12' style={{display: 'flex', padding: '20px 40px', justifyContent: 'space-around', alignContent: 'center'}}>
  <div className='col-5' style={{paddingTop: '40px'}}>
    <h3 style={{fontFamily: 'Archivo, Serif', fontWeight: 'bold', fontSize: '48px', color: '#323743'}}>Sobre o Lumera 3D</h3>
    <div style={{fontFamily: 'Inter, Serfi', fontSize: '14px', color: '#565D6D'}}>
O Lumera 3D é a solução ideal para quem busca organização, eficiência e inovação na gestão de projetos 3D. Desenvolvido com foco em simplificar processos e acabar com o caos de e-mails e planilhas desatualizadas, o Lumera 3D oferece uma plataforma completa para controle de pendências e compartilhamento de modelos 3D. 
<br></br>
<br></br>
Nosso objetivo é facilitar a comunicação e a colaboração entre equipes, 
eliminando ruídos e centralizando informações importantes em um único lugar. Seja você um profissional de engenharia, arquitetura, design ou qualquer área que trabalhe com modelos 3D, o Lumera 3D foi criado para transformar a maneira como você gerencia suas demandas. 

    </div>

  </div>
  <div className='col-6 tirarimg'><img src={sobreimg} style={{maxWidth:'692px'}}></img></div>
</div>




    <div className='col-12' style={{padding: '20px 50px'}}>
<h3 style={{fontFamily: 'Archivo, Serif', fontWeight: 'bold', fontSize: '48px', color: '#323743'}}>O que torna o Lumera 3D único? </h3>    </div>


    <div className='col-12' style={{display: 'flex', marginTop: '50px', gap: 142, flexFlow: 'row wrap', justifyContent: 'center'}}>

<div className='col-10 col-md-3' style={{ display: 'flex'}}>


    <div style={{width: '100px'}}>
        <div style={{backgroundColor: '#BDC1CA', height: '90px', width: '90px', borderRadius: '50%',
    display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center'

  }}>
       <img src={group1} width={'46px'} height={'46px'}></img>
    </div>
   
  </div>
  <div style={{paddingLeft: '23px'}}>
  <a style={{fontFamily: 'Inter, Serif', fontWeight: 'bold', fontSize: '16px', color: '#30486B'}}>Controle Total da Equipe</a><br></br>
  <div style={{fontFamily: 'Inter, serif', color: '#626E7C', marginTop: '5px', fontSize: '14px'}}>Organize sua equipe de forma eficiente. Defina permissões, atribua funções e facilite a colaboração no gerenciamento de seus projetos 3D</div>
</div>
</div>

<div className='col-10 col-md-3' style={{ display: 'flex'}}>


    <div style={{width: '100px'}}>
        <div style={{backgroundColor: '#BDC1CA', height: '90px', width: '90px', borderRadius: '50%',
    display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center'

  }}>
       <img src={group2} width={'46px'} height={'46px'}></img>
    </div>
   
  </div>
  <div style={{paddingLeft: '23px'}}>
  <a style={{fontFamily: 'Inter, Serif', fontWeight: 'bold', fontSize: '16px', color: '#30486B'}}>Gerenciamento de Modelos 3D</a><br></br>
  <div style={{fontFamily: 'Inter, serif', color: '#626E7C', marginTop: '5px', fontSize: '14px'}}>Envie e organize seus modelos 3D diretamente na plataforma. Mantenha todos os arquivos atualizados e acessíveis para sua equipe, sem complicações.</div>
</div>
</div>

    </div>

  <div className='col-12 fixmargintop' style={{display: 'flex', gap: 142, flexFlow: 'row wrap', justifyContent: 'center'}}>

<div className='col-10 col-md-3' style={{ display: 'flex'}}>


    <div style={{width: '100px'}}>
        <div style={{backgroundColor: '#BDC1CA', height: '90px', width: '90px', borderRadius: '50%',
    display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center'

  }}>
       <img src={group3} width={'46px'} height={'46px'}></img>
    </div>
   
  </div>
  <div style={{paddingLeft: '23px'}}>
  <a style={{fontFamily: 'Inter, Serif', fontWeight: 'bold', fontSize: '16px', color: '#30486B'}}>Gestão de Pendências </a><br></br>
  <div style={{fontFamily: 'Inter, serif', color: '#626E7C', marginTop: '5px', fontSize: '14px'}}>Diga adeus ao caus dos e-mails! Com o Lumera 3D, acompanhe pendencias do projeto em um só lugar. Centralize informações, delegue tarefas e mantenha sua equipe sempre atualizada.</div>
</div>
</div>

<div className='col-10 col-md-3' style={{ display: 'flex'}}>


    <div style={{width: '100px'}}>
        <div style={{backgroundColor: '#BDC1CA', height: '90px', width: '90px', borderRadius: '50%',
    display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center'

  }}>
       <img src={group4} width={'46px'} height={'46px'}></img>
    </div>
   
  </div>
  <div style={{paddingLeft: '23px'}}>
  <a style={{fontFamily: 'Inter, Serif', fontWeight: 'bold', fontSize: '16px', color: '#30486B'}}>Simplicidade e eficiência</a><br></br>
  <div style={{fontFamily: 'Inter, serif', color: '#626E7C', marginTop: '5px', fontSize: '14px'}}>Interface amigável, fácil de usar e desenvolvida para otimizar o seu tempo.</div>
</div>
</div>

    </div>

















<div className='col-12' style={{display: 'flex', paddingTop: '50px', paddingBottom: '30px', backgroundColor: 'rgb(249,250,252)', marginTop: '40px', gap: 142, flexFlow: 'row nowrap', justifyContent: 'center'}}>

<div className='col-3 tirarimg2'>

<img src={sobreimg2} ></img>


</div>
<div className='col-4' style={{ }}>

<h3 style={{fontFamily: 'Archivo, Serif', fontWeight: 'bold', fontSize: '40px', color: '#323743'}}>Nosso compromisso</h3>

<div style={{color: '#565D6D', fontSize: '14px', fontFamily: 'Inter, Serif', paddingTop: '15px'}}>

O Lumera 3D é mais do que uma ferramenta, é um parceiro no sucesso dos seus projetos. Inspirados pela perfeição e estética clássica representada no nosso símbolo, acreditamos que a organização e a funcionalidade podem, sim, andar lado a lado com a beleza e a inovação. 
<br></br>
<br></br>
Transforme a maneira como você trabalha com modelos e projetos 3D. 
Experimente o Lumera 3D e veja o futuro da gestão de projetos.

</div>


</div>

    </div>


<Rodape/>

</container>

  </>
  );
}

export default Sobre;






